<form #myForm="ngForm">
    <div class="container-fluid forgot_wrapper">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 reg_bg">
            <div class="col-lg-1 col-md-1 hidden-xs"></div>
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 forgot_left">
                <img src="/assets/images/ots_logo.png">
                <h5>Welcome {{userFirstName}} {{userLastName}} </h5>
                <span>
                    To change your password, first enter your existing password, then create a new one.
                </span>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-5 col-xs-12" style="text-align: left;">
                <strong class="titleV1">Change Password</strong>
                <div class="input-field addMandatory">
                    <div *ngIf="!showPassword">
                        <!-- <input appBlockCopyPaste name="OldPassword" tabindex="1" type="password" [(ngModel)]="password" placeholder="Password" (input)="ClearValidation()"
                            required> -->
                            <input  name="OldPassword" tabindex="1" type="password" [(ngModel)]="password" placeholder="Password" (input)="ClearValidation()"
                            required>
                        <span *ngIf="password" (click)="toggleShowPassword()" class="glyphicon glyphicon-eye-open form-control-feedback eye_modify colorwhite"
                            style="cursor: pointer; pointer-events: all;">
                        </span>
                    </div>
                    <!-- show password as type="text"  -->
                    <div *ngIf="showPassword">
                        <!-- <input appBlockCopyPaste type="text" tabindex="1" name="OldPassword" [(ngModel)]="password" (input)="ClearValidation()" placeholder="Old Password"
                            required> -->
                            <input  type="text" tabindex="1" name="OldPassword" [(ngModel)]="password" (input)="ClearValidation()" placeholder="Old Password"
                            required>
                        <span *ngIf="password" (click)="toggleShowPassword()" class="glyphicon glyphicon-eye-close form-control-feedback eye_modify colorwhite"
                            style="cursor: pointer; pointer-events: all;">
                        </span>
                    </div>
                </div>
                <div *ngIf="oldPassWordInvalid">
                    <span class="input-ErrorField">Old Password is incorrect</span>
                </div>
                <div *ngIf="oldPasswordRequired">
                    <span class="input-ErrorField">Old Password is Required</span>
                </div>
                <div class="input-field addMandatory">
                    <div *ngIf="!showNewPassword">
                        <input name="NewPassword" tabindex="2" appBlockCopyPaste type="password" tooltip="Test" [(ngModel)]="newPassword" (input)="ConfirmPasswordCheck('new');PatternCheck(myForm)"
                            [pattern]="passwordPattern" placeholder="New Password" required #npassword="ngModel">
                        <span *ngIf="newPassword" (click)="toggleShowNewPassword()" class="glyphicon glyphicon-eye-open form-control-feedback eye_modify colorwhite"
                            style="cursor: pointer; pointer-events: all;">
                        </span>
                    </div>
                    <div *ngIf="showNewPassword">
                        <input type="text" appBlockCopyPaste tabindex="2" name="NewPassword" [(ngModel)]="newPassword" (input)="ConfirmPasswordCheck('new');PatternCheck(myForm)"
                            [pattern]="passwordPattern" placeholder="New Password" required #npassword2="ngModel">
                        <span *ngIf="newPassword" (click)="toggleShowNewPassword()" class="glyphicon glyphicon-eye-close form-control-feedback eye_modify colorwhite"
                            style="cursor: pointer; pointer-events: all;">
                        </span>
                    </div>
                </div>
                <div *ngIf="newPasswordInvalid">
                    <span class="input-ErrorField">New Password should not be same as old password</span>
                </div>
                <div *ngIf="patternInValid">
                    <span class="input-ErrorField"> Password does not adhere to security policy</span>
                </div>
                <div *ngIf="newPasswordRequired">
                    <span class="input-ErrorField">New Password is Required</span>
                </div>
                <div class="input-field addMandatory">
                    <div *ngIf="!showConfirmPassword">
                        <input name="ConfirmPassword" tabindex="3" appBlockCopyPaste type="password" [(ngModel)]="confirmPassword" (input)="ConfirmPasswordCheck('confirm')"
                            placeholder="Re-Enter New Password" required>
                        <span *ngIf="confirmPassword" (click)="toggleShowConfirmPassword()" class="glyphicon glyphicon-eye-open form-control-feedback eye_modify colorwhite"
                            style="cursor: pointer; pointer-events: all;">
                        </span>
                    </div>
                    <div *ngIf="showConfirmPassword">
                        <input type="text" appBlockCopyPaste tabindex="3" name="ConfirmPassword" [(ngModel)]="confirmPassword" (input)="ConfirmPasswordCheck('confirm')"
                            placeholder="Re-Enter New Password" required>
                        <span *ngIf="confirmPassword" (click)="toggleShowConfirmPassword()" class="glyphicon glyphicon-eye-close form-control-feedback eye_modify colorwhite"
                            style="cursor: pointer; pointer-events: all;">
                        </span>
                    </div>
                </div>
                <div *ngIf="showConfirmErrorMsg">
                    <span class="input-ErrorField">Password Mismatch</span>
                </div>
                <div *ngIf="confirmPasswordRequired">
                    <span class="input-ErrorField">'Re-Enter New Password' is Required</span>
                </div>               
                <button type="button"  tabindex="4" (click)="Passwordsubmit(myForm)" class="waves-effect waves-light btn submitcustom_btn">Submit</button>
                <span *ngIf="isHidden">
                 <button type="button"  tabindex="5" (click)="OnBack()" class="waves-effect waves-light btn submitcustom_btn">Cancel</button> 
                 </span>
                
            </div>
            <div class="col-lg-4 col-md-4 col-sm-5 col-xs-12" style="text-align:left;">
                <p>
                    <br/><br/> When selecting a password, please ensure to:
                    <br/> - Choose a new password with 12 or more characters long.
                    <br/> - At least one number
                    <br/> - At least one special character('!','@', '#', '$', '~')
                    <br/> - At least one uppercase letter
                    <br/> - Must not be the username</p>
            </div>
            <div class="col-lg-1 col-md-1" style="text-align: left"></div>
        </div>
    </div>
</form>